
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';

import OrderTopTitle from '@/components/OrderInfo/OrderTopTitle.vue'
import OrderInfo from '@/components/OrderInfo/OrderInfo.vue';
import OrderServiceInfo from '@/components/OrderInfo/OrderServiceInfo.vue'
import { getOrderTaskDetail } from '@/api/orderTask';

import { checkPermissionCompanyFromOrderType, checkPermissionRole } from '@/utils/permission';
import { Type } from '../../types/permissionType';
import { bottomBtnTaskState, isFinish } from '@/utils/orderStatsUtils';

@Component({
  name: 'TaskToDetail',
  components: {
    OrderTopTitle,
    OrderInfo,
    OrderServiceInfo
  },
  filters: {
    getOrderServiceDealType(value: any) {
      switch (parseInt(value)) {
        case 1:
          value = '远程';
          break;
        case 2:
          value = '上门';
          break;
        case 3:
          value = '寄修';
          break;
        case 4:
          value = '转单';
          break;
        default:
          value = '未处理';
          break;
      }
      return value;
    },
    getAppointmentime(val: any) {
      if (val && val.length > 0) {
        if ('appointment_time' in val[0]) {
          return val[0].appointment_time;
        } else {
          return '暂无';
        }
      } else {
        return '暂无';
      }
    },
    getArraignmentState(value: any) {
      switch (parseInt(value)) {
        case 0:
          value = '未处理';
          break;
        case 1:
          value = '审批通过';
          break;
        case 3:
          value = '审批不通过';
          break;
        case 5:
          value = '审批关闭';
          break;
      }
      return value;
    }
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {},
  })
  DetailsDataQuery!: any;

  private appointmenTimeMust=false;
  private formInformation: any = {
    appointment: '',
    expedited: false,
    tag: '',
    tags: [],
    brand: [],
    device: [],
    parts: [],
    image: [],
    video: [],
    word: [],

    evaluate: '',

    costType: '',
    costValue: '',
    remark: '',
    order_task_list: []
  }
  private dynamicRemark:any = []
  private dynamicFault:any = []
  private dynamicCost:any = []
  private costList:any = []
  private partsVisible = false
  private tagVisible =false
  private deviceVisible = false

  private companyId :any= '';
  private taskId:any = '';
  private orderType :any = '';
  private enterType:any = ''; // 1 立即处理 2 协同处理 3 追加信息 4 任务完成
  private isDetail:any=true;
  private isProgress:any=false;

  private taskDetail: any = {
    order: {},
    order_service: {},
    order_task: {}
  };
  private modulesHandlePer: any = {};

  private isFinish=false
  private orderState:number = 0;
  private confirmButton = false;
  private topButtonList:any=[];
  private orderProgressData:any = {};
  private activeLeft = 'infor';
  private activeRight = 'infor';
  private dynamicOrderSend:any=[];
  private workSheetHandle() {
    window.open(
      location.protocol + (process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API_DEV) + 'OrderService/workSheetDetail?company_id=' + UserModule.getCompanyId + '&user_id=' + UserModule.getUserId + '&user_name=' + UserModule.getUserName + '&company_name=' + UserModule.getCompanyName + '&order_service_id=' + this.taskDetail.order_service.id
    );
  }
  private isWorksheet = false

  private editDialogData: any = {
    visible: false,
    title: '',
    name: '',
    inputValue: '',
    inputHint: '',
    cancel: '',
    confirm: '',
    callBack: '',
    rules: []
  };

  created() {
    if (this.DetailsDataQuery && this.DetailsDataQuery.companyId) {
      this.companyId = this.DetailsDataQuery.companyId;
      this.taskId = this.DetailsDataQuery.taskId;
      this.orderType = this.DetailsDataQuery.orderType;
      this.enterType = this.DetailsDataQuery.enterType;
      this.isProgress = parseInt(this.DetailsDataQuery.isProgress as string) === 1;
    } else {
      this.companyId = this.$route.query.companyId;
      this.taskId = this.$route.query.taskId;
      this.orderType = this.$route.query.orderType;
      this.enterType = this.$route.query.enterType;
      this.isProgress = parseInt(this.$route.query.isProgress as string) === 1;
    }

    this.getTaskDetail();
  }

  private toggleOldHandle(row: any) {
    this.$router.push({
      path: '/Task/todeal',
      query: {
        'taskId': this.taskId,
        'companyId': this.companyId,
        'orderType': this.orderType,
        'enterType': this.enterType
      }
    });
  }

  // 点击返回 返回到任务列表
  private backToTaskList() {
    this.$router.go(-1);
  }
  // 获取任务详情
  private getTaskDetail() {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId
    };
    getOrderTaskDetail(params).then(res => {
      const data = res.data;
      if (res.data) {
        this.taskDetail = res.data;
        if (this.taskDetail.order.parts_list) {
          for (var bean of this.taskDetail.order.parts_list) {
            bean.str =
                this.isNull(bean.parts_name) +
                '/' +
                this.isNull(bean.parts_model_name) +
                '/' +
                this.isNull(bean.parts_amount) +
                '/' +
                this.isNull(bean.parts_unit_price) +
                '/' +
                this.isNull(bean.parts_price) +
                '/' +
                this.isNull(bean.parts_attribute_name);
          }
        }
        if (this.taskDetail.order_service.video_list) {
          for (var bean2 of this.taskDetail.order_service.video_list) {
            bean2.img_url = bean2.full_path;
          }
        }
        this.dynamicCost = this.taskDetail.order.order_price;
        this.dynamicFault = this.taskDetail.order.fault_list;
        this.dynamicRemark = this.taskDetail.order.order_remark;

        if (this.taskDetail.order.order_task) {
          this.taskDetail.order.order_task.forEach((element:any) => {
            if (!this.dynamicRemark) {
              this.dynamicRemark = []
            }
            this.dynamicRemark.push({
              classify_name: '',
              remark: "【维修小结】" + element.fix_summary,
              addtime: element.finish_time,
              user_name: element.user_name })
          });
        }
        // 寄修信息
        if (this.taskDetail.order_task && this.taskDetail.order_task.order_send) {
          let outsend = {
            type: '1',
            title: '寄出信息',
            name: this.taskDetail.order_task.order_send.send_name,
            mobile: this.taskDetail.order_task.order_send.send_mobile ? this.taskDetail.order_task.order_send.send_mobile : this.taskDetail.order_task.order_send.send_phone_num,
            address: this.taskDetail.order_task.order_send.send_province_name + this.taskDetail.order_task.order_send.send_city_name + this.taskDetail.order_task.order_send.send_district_name + this.taskDetail.order_task.order_send.send_address,
            deliveryName: this.taskDetail.order_task.order_send.send_express_name,
            deliveryNumber: this.taskDetail.order_task.order_send.send_express_number
          }
          this.dynamicOrderSend.push(outsend);

          let insend = {
            title: '寄回信息',
            name: this.taskDetail.order_task.order_send.reply_name,
            mobile: this.taskDetail.order_task.order_send.reply_mobile ? this.taskDetail.order_task.order_send.reply_mobile : this.taskDetail.order_task.order_send.reply_phone_num,
            address: this.taskDetail.order_task.order_send.reply_province_name + this.taskDetail.order_task.order_send.reply_city_name + this.taskDetail.order_task.order_send.reply_district_name + this.taskDetail.order_task.order_send.reply_address,
            deliveryName: this.taskDetail.order_task.order_send.reply_express_name,
            deliveryNumber: this.taskDetail.order_task.order_send.reply_express_number
          }
          this.dynamicOrderSend.push(insend);
        }

        this.formInformation.tags = this.taskDetail.order.tags;
        this.formInformation.brand = this.taskDetail.order_service.brand_list;
        this.formInformation.device = this.taskDetail.order_service.device_list;
        this.formInformation.parts = this.taskDetail.order.parts_list;
        this.formInformation.image = this.taskDetail.order.order_image;
        this.formInformation.video = this.taskDetail.order_service.video_list;
        if (this.taskDetail.order_service.document_list) {
          this.formInformation.word = this.taskDetail.order_service.document_list;
        } else {
          this.formInformation.word = [];
        }
        if (this.formInformation.word) {
          this.formInformation.word.map(function(item:any) {
            item.name = item.original_name;
          });
        }
        this.formInformation.order_task_list = this.taskDetail.order_task_list;
        if (this.taskDetail.order_service.servicer_appointment_timestamp && parseInt(this.taskDetail.order_service.servicer_appointment_timestamp) !== 0) {
          this.formInformation.appointment = this.taskDetail.order_service.servicer_appointment_timestamp + '000';
        }

        this.initButtonList(this.taskDetail);
        if (this.isProgress) {
          this.activeLeft = 'schedule'
        }
      }
      // else {
      //   this.formInformation = {};
      // }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private initButtonList(taskDetail:any) {
    this.orderState = bottomBtnTaskState(parseInt(taskDetail.order_task.state))
    this.confirmButton = [2, 6].includes(this.orderState) && parseInt(taskDetail.order.order_type) !== 4 && parseInt(this.enterType) !== 3 && !this.isDetail;
    this.isFinish = isFinish(
      parseInt(this.taskDetail.order_task.state)
    );
    this.isWorksheet = (this.orderState >= 3) && checkPermissionCompanyFromOrderType(this.taskDetail.order_task.company_id,
      Type.ORDER_WORK_SHEET,
      this.taskDetail.order.order_type);
    this.topButtonList = [
      { id: 1,
        style: 'color: #f00',
        show: [1, 2, 3, 4, 5, 6].includes(this.orderState) && parseInt(taskDetail.order.order_type) !== 4 &&
        checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.ORDER_DEAL, taskDetail.order.order_type),
        info: '上报' },
      { id: 5,
        style: 'color: #f00',
        show: [1, 2, 3, 4, 5, 6].includes(this.orderState) && parseInt(taskDetail.order.order_type) !== 4 &&
        checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.PauseTask, taskDetail.order.order_type) &&
        checkPermissionRole(taskDetail.order_task.company_id, Type.PauseTask),
        info: parseInt(taskDetail.order_task.pause_last_state) === 1 ? '继续' : '暂停' },

      // { id: 2,
      //   show: [1, 2, 3, 4, 5, 6].includes(this.orderState) && parseInt(taskDetail.order.order_type) !== 4 &&
      //          checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.TASK_COORDINATION, taskDetail.order.order_type),
      //   info: '协同处理' },
      { id: 3,
        show: !this.isFinish && this.orderState === 4 &&
              checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.TASK_DEAL, taskDetail.order.order_type),
        info: '确认收货' },
      { id: 4,
        show: !this.isFinish && this.orderState === 5 &&
        checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.TASK_DEAL, taskDetail.order.order_type),
        info: '寄回' },

    ]
  }

  private isNull(val: any) {
    if (val) {
      return val;
    } else {
      return '~';
    }
  }
  // hud
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
